import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import React from 'react';
import { SvgIcon } from '@mui/material';
const HelpQuestion = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.3 18.1h2.6v2.6h-2.6v-2.6M12 3.3c4.7.2 6.7 4.9 3.9 8.4-.7.9-1.9 1.4-2.5 2.2-.6.7-.6 1.6-.6 2.5h-2.6c0-1.5 0-2.7.6-3.6.6-.9 1.7-1.4 2.5-2 2.1-2 1.6-4.7-1.3-4.9-1.4 0-2.6 1.2-2.6 2.6H6.8c0-2.9 2.3-5.2 5.2-5.2z"
}))));
export default HelpQuestion;